export function Button({
  children,
  onClick,
  variant = "primary",
  className = "",
  color = "black" // Add color prop with default value "black"
}) {
  const baseClasses =
    "relative p-[13px] flex gap-[8px] items-center justify-center w-full font-inter rounded-[16px] text-base leading-6 font-semibold";
  
  // Modify variantClasses to include color options
  const variantClasses = 
    variant === "primary"
      ? color === "black" 
        ? "text-white bg-black !font-medium"
        : "text-black bg-white border border-black !font-medium"
      : "button-secondary";

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${className}`}
      onClick={onClick}
    >
      <div className="flex gap-[10px] items-center justify-center">
        {children}
      </div>
    </button>
  );
}